<template>
	<li class="list-item" :class="[colorClass ? 'text-' + colorClass : '', {'justify-center': props.center}]" :style="{color: colorHex}" role="listitem">
		<Icon v-if="props.icon !== false" :icon="props.icon !== true ? props.icon : icons.info"/>
		<span v-if="props.title" class="font-bold">{{ props.title }}:&nbsp;</span>
		<span v-if="props.text">{{ props.text }}</span>
		<slot/>
		<tooltip v-if="props.help" right :text="props.help" with-touch class="flex items-center">
			<Icon size="14" class="ml-4" color="gray-300" force-size :icon="icons.help"/>
		</tooltip>
	</li>
</template>

<script setup lang="ts">
import {type ListItemComponentProps, useListItemComponent} from "../../../composables/useListItemComponent";
import {helpIcon, infoIcon} from "../../../config";

const props = withDefaults(defineProps<{
	icon?: string | boolean,
	title?: string,
} & ListItemComponentProps>(), {
	icon: true
});

const {colorClass, colorHex} = useListItemComponent(props);

const icons = {
	help: helpIcon,
	info: infoIcon
}
</script>